import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { Button, AuthContainer, AlertBox, Support } from '@/components';

import styles from './SignUpSuccess.module.sass';

interface SignUpSuccessProps {}

const SignUpSuccess: FC<SignUpSuccessProps> = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const clickHandler = () => {
    navigate('/signin');
  };

  return (
    <AuthContainer
      title={t('translation.signup_success_title')}
      description={
        <AlertBox type="info">
          {{
            title: t('translation.tips'),
            description: (
              <div className={styles.tips}>
                <ul className={styles.list}>
                  <li>{t('translation.tips_signup_success_email_sent')}</li>
                  <li>{t('translation.tips_signup_success_try_to_login')}</li>
                  <li>
                    {t('translation.tips_signup_success_follow_instructions')}
                  </li>
                  <li>
                    <div className={styles.wrapper}>
                      <span className={styles.gap}>
                        {t('translation.contact_support')}
                      </span>
                      <Support />
                    </div>
                  </li>
                </ul>
              </div>
            ),
          }}
        </AlertBox>
      }
      buttons={
        <div>
          <Button size="m" minWidth={240} corner="rect" onClick={clickHandler}>
            {t('translation.ok')}
          </Button>
        </div>
      }
    />
  );
};

export default SignUpSuccess;
